import { render, staticRenderFns } from "./ListModelosPage.vue?vue&type=template&id=2fbdae12"
import script from "./ListModelosPage.vue?vue&type=script&lang=js"
export * from "./ListModelosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports